import { FloatingLabel, Form, Image } from 'react-bootstrap';
import React, { ChangeEventHandler } from 'react';
import { ConsumerLocale } from '../types/ConsumerLocale';
import loading from '../assets/loading.gif';

export interface LanguageFormSelectProps {
	languages: ConsumerLocale[] | [];
	title: string;
	subTitle?: string;
	value: string | undefined;
	onChange: ChangeEventHandler<HTMLSelectElement> | undefined;
	isLoading?: boolean;
}

const LanguageFormSelect = (props: LanguageFormSelectProps) => {
	const renderLanguageOptions = () => {
		return (
			<>
				{props.languages !== undefined && props.languages.length !== 0 ? (
					Object.entries(props.languages).map(([key, value], index) => {
						return (
							<option key={index} value={value.consumerLocaleId}>
								{value.name}
							</option>
						);
					})
				) : (
					<></>
				)}
			</>
		);
	};

	return (
		<>
			<div className="position-relative">
				<FloatingLabel label={props.title}>
					<Form.Select value={props.value} onChange={props.onChange} disabled={props.isLoading}>
						<option value={''}>{props.subTitle}</option>
						{renderLanguageOptions()}
					</Form.Select>
				</FloatingLabel>

				{props.isLoading && (
					<div
						className="position-absolute top-50 start-50 translate-middle"
						style={{ zIndex: 10 }}
					>
						<Image id="loading-gif-dropdown" src={loading} alt={'loading'} />
					</div>
				)}
			</div>
		</>
	);
};

export default LanguageFormSelect;
